@layer module {
.sliding-tabs {
            position: relative;
            align-self: flex-start;
            max-width: 100%;
    }

.sliding-tabs__thumb {
            position: absolute;
            top: 0;
            left: 0;
            z-index: 0;
            width: 0;
            height: 0;
            opacity: 0;
            pointer-events: none;
            transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1), width 0.3s cubic-bezier(0.4, 0, 0.2, 1), height 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    }

.sliding-tabs__thumb[data-ready='true'] {
            opacity: 1;
    }

      @media (max-width: 719px) {
                .sliding-tabs {
                        align-self: stretch;
                    }
          }

      @media (prefers-reduced-motion: reduce) {
                .sliding-tabs__thumb {
                        transition: none;
                    }
          }
} // layer module










@layer app {
.sliding-tabs__thumb {
            border-radius: $size-12;
    }

.sliding-tabs__thumb {
            background: var(--color-brand);
            box-shadow: var(--shadow-brand-lift);
    }
} // layer app










@layer context {
.sliding-tabs :global(.tab-item) {
            position: relative;
            z-index: 1;
            transition: color 0.1s ease;
    }

.sliding-tabs :global(.tab-item.selected) {
            background: transparent;
            box-shadow: none;
            animation: sliding-tab-label-on 0.15s ease 0.15s both;
    }

@keyframes sliding-tab-label-on {
            from {
                        color: var(--text-body);
                    }

            to {
                        color: var(--color-on-brand);
                    }
    }

      @media (prefers-reduced-motion: reduce) {
                .sliding-tabs :global(.tab-item.selected) {
                        animation: none;
                    }
          }
} // layer context
